import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import Swal from "sweetalert2";
import { RunningWithErrorsOutlined } from "@mui/icons-material";



function BillUpgradeCSHP(props) {

    const navi = useNavigate();
    const { onChildError } = props; // Nhận các props từ cha

    const [price, setPrice] = useState(null);
    const [usdPrice, setUsdPrice] = useState("0.00");
    const [billDetails, setBillDetails] = useState([]);
    const [checkeror, setcheckerro] = useState("");
    const [discountprice, setdiscountprice] = useState(null);
    const [promoCode, setPromoCode] = useState("");
    const [discountSuccess, setDiscountSuccess] = useState(""); // New state for success message

    const [finalSubtotal, setFinalSubtotal] = useState(props?.baseAmount);
    // console.log("props?.baseAmount", props?.baseAmount)
    const [searchParams] = useSearchParams(); // Hook lấy tham số từ URL

    // Chuyển đổi chu kỳ thanh toán
    // console.log("props.selectedFeatures", props.selectedFeatures[0]?.price)
    useEffect(() => {
        if (props?.baseAmount !== undefined) {
            setFinalSubtotal(props?.baseAmount);
        }
    }, [props?.baseAmount]);

    useEffect(() => {
        // Lấy giá trị mã khuyến mãi từ URL
        const urlPromoCode = searchParams.get("promocode");
        if (urlPromoCode) {
            setPromoCode(urlPromoCode);
        }
    }, [searchParams]);
    useEffect(() => {
        if (props.totalAmount && props.totalAmount > 0) {
            Cookies.set("orderAmount", props.totalAmount, { expires: 1 }); // Lưu cookie trong 1 ngày
            const convertedUsdPrice = (props.totalAmount / 24000).toFixed(2);
            setUsdPrice(convertedUsdPrice);
            setPrice(props.totalAmount);
            // console.log("Saved order amount:", props.totalAmount);
        }
        setcheckerro("");
    }, [props.totalAmount, props.selectedChildSystem]);
    // useEffect(() => {
    //     console.log("selectedSystem", props?.selectedproduct)
    //     console.log("selectedRegion", props?.selectedRegion);
    //     console.log("selectedChildSystem", props?.selectedChildSystem)
    //     console.log("packages", props?.packages)
    //     console.log("Period", props?.selectedCycle)
    //     console.log("selectedFeatures", props?.selectedFeatures)
    //     console.log("Subtotal", props?.baseAmount)
    //     console.log("Discount", props?.pricekm)
    //     console.log("Post-Discount", props?.postdiscount)
    //     console.log("Payment", price)
    // }, [props?.regions, props?.selectedChildSystem, props?.packages, props?.selectedFeatures, props?.baseAmount, price, props?.selectedSystem])
    // useEffect(() => {
    //     const savedOrderAmount = Cookies.get("orderAmount");
    //     if (savedOrderAmount) {
    //         // console.log("Loaded order amount from cookie:", savedOrderAmount);
    //         setPrice(parseFloat(savedOrderAmount));
    //     }
    // }, []);

    // if (price === null) {
    //     return <div>Đang tải thông tin hóa đơn...</div>;
    // }
    const calculatePriceDifference = () => {
        if (props?.package?.cshp_price != null && props?.currentpackageprice != null && props?.backup === "1") {
            return (props?.package?.cshp_price + props?.package?.cshp_price_storage) - props?.currentpackageprice;
        }
        else {
            return props?.package?.cshp_price - props?.currentpackageprice;

        }
    };

    const handleCreateInvoice = async () => {
        // const { promoCode, finalSubtotal, price, discountprice } = props;
        const totalAmount = calculatePriceDifference();

        const package_id = props?.package?.id;
        const domain_hosting_name = props?.hostname;
        let backup_id = 0;
        if (props?.backup === "1") {
            backup_id = 1;
        }
        const operating = props?.selectedChildSystem;
        const region_id = props?.regions?.id;



        const data = {
            package_id: package_id,
            currency: "VND",
            invoice_item_des: "Service Cshp",
            region_id: region_id,
            image_id: operating,
            backup_id: backup_id,
            domain_hosting_name: domain_hosting_name,
            order_detail_des: "Service Cshp",
            total: calculatePriceDifference() + (calculatePriceDifference() * 0.1),
            promo_code: promoCode || "",
            sub_total: calculatePriceDifference(),
            tax: calculatePriceDifference() * 0.1,
            tax_rate: 0.1,
            payment_method: "VND",
            invoice_items: [
                {
                    package_id: package_id,
                    sub_total: calculatePriceDifference(),
                    taxed: 1,
                    payment_method: "VND",
                    des: "Service Cshp",
                    notes: "Invoice Item for package upgrade",
                    current_package_id: props?.currentpackageid,
                    order_id: props?.order_detailsID,
                }
            ]
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/cshp-create-invoice-changepackage`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Cookies.get("Token")}`
                }
            });

            console.log('API response:', response);

            if (response.status === 201 && response.data.status === 200) {
                setcheckerro("Thanh toán thành công!");
                setTimeout(() => {
                    navi('/cshp');
                    window.location.reload();
                }, 2000);
            } else {
                setcheckerro("Số tiền phải lớn hơn 50.000đ: ");
            }





        } catch (error) {
            console.error('Error creating invoice:', error);
            setcheckerro("Đã xảy ra lỗi khi tạo hóa đơn.");
        }
    };
    console.log("backup", props?.backup)

    // const updateWalletPayment = async (invoiceID, totalAmount, token) => {
    //     try {
    //         const data = await updateWallet(totalAmount);
    //         console.log("Wallet updated successfully:", data);

    //         await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-transaction`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Authorization": `Bearer ${token}`
    //             },
    //             body: JSON.stringify({
    //                 status: 1,
    //                 orderId: invoiceID,
    //                 amount: totalAmount,
    //                 gatewayId: 3,
    //                 type: 1,
    //             }),
    //         });

    //         await fetch(`${process.env.REACT_APP_API_URL}/api/v1/update-payment-downgrade`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Authorization": `Bearer ${token}`
    //             },
    //             body: JSON.stringify({
    //                 status: "COMPLETED",
    //                 invoiceId: invoiceID,
    //                 paymentMethod: "wallet"
    //             }),
    //         });

    //         window.location.href = '/thank-you/bank';
    //     } catch (error) {
    //         console.error("Error updating wallet:", error);
    //     }
    // };


    const handleDiscount = () => {
        if (promoCode.toLowerCase() === "tidadigi") {
            const discount = 0.4 * props?.baseAmount;
            setdiscountprice(discount);
            const updatedSubtotal = props?.baseAmount - discount;
            setFinalSubtotal(updatedSubtotal);
            setcheckerro("");
            setDiscountSuccess("Mã của bạn đã được áp dụng.");

        } else {
            setcheckerro("Mã không hợp lệ");
            setDiscountSuccess("");

        }
    };

    console.log("props?.curentpackage?.cshp_price_storage", props?.curentpackage?.cshp_price_storage)

    return (
        <div className="invoice-container container p-3" style={{ background: "#f7faff", borderRadius: "8px" }}>
            <div className="summary-section">
                <h3 style={{ color: "#007bff", fontWeight: "bold", textAlign: "center", marginBottom: "30px", marginTop: "10px" }}>Summary</h3>
                {/* 
                <div className="row summary-item mb-2">
                    <div className="col-6">Name</div>
                    <div className="col-6 text-end">{props?.selectedproduct?.name || "N/A"}</div>
                </div> */}
                <div className="row summary-item mb-2">
                    <div className="col-6">Current Plan <span style={{ fontSize: "12px" }}>{props?.currentpackagename}</span></div>

                    <div className="col-6 text-end">
                        {props?.currentpackageprice != null
                            ? props?.currentpackageprice.toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>

                <hr></hr>

                <div className="row summary-item mb-2">
                    <div className="col-6">New Plan <span style={{ fontSize: "12px" }}>{props?.package?.name}</span></div>
                    <div className="col-6 text-end">
                        {props?.package?.cshp_price != null
                            ? props?.package?.cshp_price.toLocaleString("vi-VN")
                            : "N/A"}
                    </div>
                </div>




                {props?.backup === "1" ? (
                    <div className="row summary-item mb-3">
                        <div className="col-6">Backup
                        </div>
                        <div className="col-6 text-end">
                            {props?.package?.cshp_price_storage}
                        </div>
                    </div>
                ) : null}






                {/* {props.backupselected === "1" ? (
                    <div className="row summary-item mb-3">
                        <div className="col-6">Backup: Có </div>
                        <div className="col-6 text-end">
                            {(props?.package?.cshp_price_storage) !== null
                                ? (props?.package?.cshp_price_storage)
                                : "N/A"}
                        </div>

                    </div>
                ) : (
                    null
                )} */}
                <hr></hr>
                <div className="row summary-item mb-3">
                    <div className="col-6"><h4>Subtotal</h4></div>
                    <div className="col-6 text-end">
                        {props?.package?.cshp_price != null
                            ? calculatePriceDifference()
                            : "N/A"}
                    </div>

                </div>
                <div className="row summary-item mb-3">
                    <div className="col-6">Tax(10%)</div>
                    <div className="col-6 text-end">
                        {calculatePriceDifference() * 0.1}

                    </div>
                </div>



                {/* Tổng thanh toán */}
                <div className="row summary-item mb-3">
                    <div className="col-6">
                        <h4>Total</h4>
                    </div>
                    <div className="col-6 text-end">
                        {props?.package?.cshp_price != null
                            ? calculatePriceDifference() + calculatePriceDifference() * 0.1
                            : "N/A"}
                    </div>
                </div>
                <h5 style={{ color: "green", backgroundColor: "#d4edda", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="success-message">
                    {discountSuccess}
                </h5>
                <h5 style={{ color: "red", backgroundColor: "#f8d7da", fontSize: "14px", fontWeight: "bold", textAlign: "center" }} className="error-message">{checkeror}</h5>
            </div>

            {/* Nút thanh toán */}
            <div className="checkout-button-container mt-4 text-center">
                {/* <PayPalScriptProvider
                    options={{
                        "client-id": "ASMqZ4b9b8uMhsKouyqaEAkZ8s3EyKWk7XzFN_pe5VV-7i0YB7fpkjAbglNiUHTd_YFBKAb7t1oQj5Oq", // Thay bằng Client ID thật của bạn
                    }}
                >
                    <PayPalButtons
                        createOrder={(data, actions) => {
                            const currentUsdPrice = (price / 23000).toFixed(2);
                            if (!currentUsdPrice || currentUsdPrice <= 0) {
                                alert("Giá trị thanh toán không hợp lệ. Vui lòng kiểm tra lại.");
                                return;
                            }

                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: currentUsdPrice,
                                        },
                                    },
                                ],
                            });
                        }}
                        onApprove={(data, actions) => {
                            return actions.order.capture().then((details) => {
                                alert("Thanh toán thành công!");
                                // console.log("Transaction Details:", details);

                            });
                        }}
                        onCancel={() => {
                            alert("Bạn đã hủy giao dịch. Vui lòng thử lại nếu cần.");
                            // console.log("Giao dịch bị hủy bởi người dùng.");

                        }}
                        onError={(err) => {
                            console.error("Lỗi thanh toán:", err);
                            alert("Đã xảy ra lỗi khi thanh toán.");
                        }}
                    />
                </PayPalScriptProvider> */}


                <button
                    className="checkout-button"
                    onClick={handleCreateInvoice}
                    style={{
                        width: "100%",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "bold"
                    }}
                >
                    Thực hiện
                </button>

            </div>
        </div>
    );
}

export default BillUpgradeCSHP;
